export enum SyncStatus {
  CAPTURED = "captured",
  PENDING = "pending",
  SYNCING = "syncing",
  SYNCED = "synced",
  FAILED = "failed",
}

export interface Photo {
  id: string;
  filename: string;
  fullBlob: Blob;
  thumbnailBlob: Blob;
  createdAt: Date;
  productId: string; // Produit `AAAA-MM-JJ/HHMMSS` : le groupe de la photo, et son chemin distant
  syncStatus: SyncStatus;
  accountId: string; // MSAL homeAccountId - identifies which account owns this photo
  accountEmail: string; // User email for display purposes
  lastError?: string; // Cause du dernier échec d'envoi, affichée sur la vignette
}
